<template>
  <v-container
    text-center
    fluid
    mt-3>
    <v-layout
      wrap
      justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
        xl4
        class="mb-5">
        <v-card class="py-5">
          <div class="mb-5">
            <WalkWithTitleIcon />
          </div>

          <v-layout
            wrap
            justify-center>
            <v-flex
              xs6
              class="my-5">
              <v-btn
                large
                block
                color="success"
                @click="loginLINE();">
                LINEログイン
              </v-btn>
            </v-flex>
            <v-flex xs11>
              <div class="text-size-1 mt-2 mb-3">
                ※
                <v-btn
                  text
                  x-small
                  class="px-0 text-size-1"
                  color="info"
                  @click="moveTerms();">
                  利用規約
                </v-btn>
                、
                <v-btn
                  text
                  x-small
                  class="px-0 text-size-1"
                  color="info"
                  @click="movePrivacy();">
                  プライバシーポリシー
                </v-btn>
                に同意の上ご利用ください
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WalkWithTitleIcon from '../components/SVGs/WalkWithTitleIcon';
import utils from '../libs/utils';
import ga from '../libs/ga';

export default {
  components: {
    WalkWithTitleIcon,
  },
  created: function() {
    this.$store.commit('updateLogin', false);
  },
  methods: {
    loginLINE: function() {
      ga.loginPage.login(this.$ga);

      // LINEログイン後の画面で登録処理後にリダイレクトするページ
      localStorage.setItem('redirect', '/trip');

      const lineUrl = utils.setupLINELogin();
      location.href = lineUrl;
    },
    moveTerms: function() {
      ga.loginPage.terms(this.$ga);
      this.$router.push('/terms');
    },
    movePrivacy: function() {
      ga.loginPage.privacy(this.$ga);
      this.$router.push('/privacy');
    },
  },
};
</script>
